<template>
    <div id="servicos">
           <div class="container" id="servicos-desc">
                <div class="row">
                    <div class="col-lg-8 col-md-8 col-sm-*" id="servico_descricao">
                        <!-- <img src="../assets/images/5.jpg" alt="" id="img_servicos">-->
                        <h4>Serviços</h4>
                        <hr>
                        <p>
                            Uma boa equipa, profissionais competentes, metas claras, capacidade e visão, estes são fatores de sucesso que podes controlar. No entanto, convém saber que nem tudo depende de si, imprevistos e acidentes podem mudar o rumo da sua empresa de um momento para outro. Felizmente pode contar com a experiência da <strong>C&JA</strong> nos imprevistos, com mediadores dinâmicos, experientes e dedicados.
                        </p>
                        <p>
                            Experiência e Know How na atividade, tem como objetivo, prestar serviços
                            de assessoria e consultoria de seguros, estudar, gerir a sua carteira de
                            seguros, obtendo os melhores resultados, as melhores soluções com redução
                            de custos, temos para sua empresa os seguintes produtos:
                        </p>
                        <ul>
                            <li>Seguros automóvel com e sem danos próprios;</li>
                            <li>Seguros de Responsabilidade Civil Exploração;</li>
                            <li>Seguros de acidente de trabalho e doenças profissionais;</li>
                            <li>Seguros de saúde;</li>
                            <li>Seguros multirriscos para instalações comerciais e industriais;</li>
                            <li>Seguros de equipamentos e máquinas;</li>
                            <li>Seguros de construção, montagem;</li>
                            <li> Seguros de embarcações e aeronaves, etc...</li>
                        </ul>
                        <p>
                            Fazemos análise das melhores condições de seguros, sem custos adicionais
                            de acordo com artigo 3º ponto 4 do decreto executivo n.º 7/03 de 24 de
                            janeiro. Disponibilizando lhe um acompanhamento personalizado na
                            resolução de sinistros, em caso de acidente, fazemos mediação de tudo,
                            evitando ter que contatar à seguradora, sofrer pressão por parte do
                            sinistrado e custos adicionais.
                        </p>
                        <p>É esta capacidade que vale-nos à confiança dos nossos clientes.</p>
                        <span> <i class="fas fa-clipboard-list"></i>  Especialização dos Serviços</span>
                        <div id="detalhes_servicos">
                            <div class="card">
                                <div class="card-header">
                                    <a href="#reparacao_pc" class="card-link" data-toggle="collapse">&#10095; Consultoria <i class="fas fa-caret-down"></i> </a>
                                </div>
                                <div id="reparacao_pc" class="collapse show" data-parent="#detalhes_servicos">
                                    <div class="card-body">
                                        <p>Identificamos as necessidades e assessoramos o cliente na
                                        escolha da melhor Seguradora, levando em consideração a solidez da
                                        Instituição, sua estrutura, qualidade de atendimento e o melhor equilíbrio
                                        entre custo e benefício de seus produtos e serviços.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header">
                                    <a href="#reparacao_impressoras" class="card-link" data-toggle="collapse">&#10095; Análise de Risco <i class="fas fa-caret-down"></i></a>
                                </div>
                                <div id="reparacao_impressoras" class="collapse" data-parent="#detalhes_servicos">
                                    <div class="card-body">
                                        <p>Identificamos as possibilidades de perdas e danos e
                                        recomendamos as coberturas adequadas para o ressarcimento de
                                        eventuais prejuízos. 
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header">
                                    <a href="#reparacao_smartphones" class="card-link" data-toggle="collapse">&#10095; Gestão da carteira de Seguro <i class="fas fa-caret-down"></i></a>
                                </div>
                                <div id="reparacao_smartphones" class="collapse" data-parent="#detalhes_servicos">
                                    <div class="card-body">
                                        <p>Observamos as mudanças ocorridas
                                        durante a vigência das apólices, sejam mercadológicas ou do próprio 
                                        contrato, resguardando os direitos e deveres do Segurado. Esclarecemos e
                                        ajudamos os nossos clientes na escolha dos melhores seguros para os seus
                                        bens, ajudando-os na resolução dos eventuais sinistros que lhe ocorram. </p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header">
                                    <a href="#reparacao_son" class="card-link" data-toggle="collapse">&#10095; Renovação do Seguro  <i class="fas fa-caret-down"></i></a>
                                </div>
                                <div id="reparacao_son" class="collapse" data-parent="#detalhes_servicos">
                                    <div class="card-body">
                                        <p>Comunicamos aos Segurados sobre a
                                            necessidade de renovação do contrato de seguro, que frequentemente é
                                            anual e automática, informando prazos, custos e condições gerais, evitando
                                            interrupção da cobertura securitária. </p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header">
                                    <a href="#reparacao_ups" class="card-link" data-toggle="collapse">&#10095; Defensor <i class="fas fa-caret-down"></i></a>
                                </div>
                                <div id="reparacao_ups" class="collapse" data-parent="#detalhes_servicos">
                                    <div class="card-body">
                                        <p>Defendemos o cliente, com as técnicas dos Seguros, e o seu
                                            funcionamento e interpretamos as cláusulas das garantias das apólices. </p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header">
                                    <a href="#reparacao_domesticos" class="card-link" data-toggle="collapse">&#10095; Organização <i class="fas fa-caret-down"></i></a>
                                </div>
                                <div id="reparacao_domesticos" class="collapse" data-parent="#detalhes_servicos">
                                    <div class="card-body">
                                        <p>Sem os nossos serviços, não terá, no caso de sinistro o
                                        auxílio precioso para o ajudar a resolver o seu sinistro e terá de os resolver
                                        sozinho com custos adicionais para si, além de não ter uma defesa para os
                                        seus interesses. 
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header">
                                    <a href="#reparacao_domesticos" class="card-link" data-toggle="collapse">&#10095; Zelamos pelos interesses do cliente <i class="fas fa-caret-down"></i></a>
                                </div>
                                <div id="reparacao_domesticos" class="collapse" data-parent="#detalhes_servicos">
                                    <div class="card-body">
                                        <p>Sem prejudicar a Seguradora, dentro
                                        daquilo que o cliente tem direito. E, procuramos outras alternativas de
                                        garantias e preços a apresentar aos clientes e estamos sempre prontos a
                                        analisar as suas reclamações. 
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-*" id="section_agendamento">
                        <h6 id="agendamento"> <i class="fas fa-calendar-alt"></i> Solicite a Adesão/Revisão do seu Seguro</h6>
                        <div id="parent_form_agendamento">
                            <form action="">
                                <div class="form-group">
                                    <label for="">Seleciona o Serviço</label>
                                    <select name="" id="" class="form-control">
                                        <option value="">Adesao</option>
                                        <option value="">Revisao</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label for="">Data</label>
                                    <input type="date" name="" id="" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label for="">Nome (singular/empresa)</label>
                                    <input type="email" name="" id="" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label for="">E-mail</label>
                                    <input type="email" name="" id="" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label for="">Telefone</label>
                                    <input type="email" name="" id="" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label for="">Breve descrição</label>
                                    <textarea name="" id="" cols="30" rows="5" class="form-control"></textarea>
                                </div>
                                <a class="btn" id="btn_agendamento" href="#">Agendar Assistência</a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
export default {
    
}
</script>
<style scoped>
    #servicos{
        border: 2px solid transparent;
    }
    #servicos-desc{
        margin-top: 6%;
        padding: 1.5% 0 0 0;
    }
    #img_servicos{
        width: inherit;
    }
    h4{
        text-transform: uppercase;
        font-family: ubuntu;
        color: #8EC03B;
    }
    h3,h6{
        text-align: center;
        font-family: ubuntu;
    }
    
    .container{
        margin-top: .1%;
        margin-bottom: 2%;
    }
    #detalhes_servicos .card-link{
        color: #000
    }
    #servico_descricao p{
        text-align: justify;
    }
    #section_agendamento{
        margin-top: 2%;
    }
    #parent_form_agendamento{
        border: 1px solid rgb(0, 0, 0,0.8);
        border-radius: 10px;
    }
    #parent_form_agendamento>form{
        padding: 4%;
        
    }
    #btn_agendamento{
        background: #8EC03B;
        color: #fff;
        margin-left: 25%;
    }
</style>